import { ChartHeader } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/ChartHeader";
import { Chart } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/Chart";
import { Legends } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/Legends";
import {
    OverlapOvertimeContext,
    getInitialValue,
} from "app/pages/website-analysis/audience-overlap/OverlapOverTime/context";
import type { FC } from "react";
import React from "react";
import type { IData } from "app/pages/website-analysis/audience-overlap/SharedVisitorsTable/sharedTypes";
import type { ISiteLegendItems } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelAnalysisChart/ChannelAnalysisChartContainer";
import styled from "styled-components";
import { SitesChartLoaderContainer } from "pro-features/pages/segments/components/benchmarkOvertime/StyledComponents";
import { GraphLoader } from "pro-features/components/Loaders/src/ExpandedTableRowLoader/ExpandedTableRowLoader";
import { Box } from "@similarweb/ui-components";
import { ChartDelimiter } from "app/components/React/Charts/Common/ChartDelimiter";

interface IOverlapOverTimeProps {
    rawData: IData;
    chosenSitesLegends: ISiteLegendItems;
    isLoading: boolean;
}

const Container = styled(Box)`
    width: 100%;
    height: auto;
    border-radius: 6px;
    margin-top: 24px;
    padding: 24px 0px;
`;

const ContentContainer = styled.div`
    display: flex;
    padding: 26px 24px 0px 24px;
    justify-content: center;
`;

export const OverlapOverTime: FC<IOverlapOverTimeProps> = (props) => {
    const { rawData, chosenSitesLegends, isLoading } = props;
    const chartRef = React.useRef<HTMLDivElement>(undefined);
    return (
        <Container data-automation="overlap-overtime-container">
            <OverlapOvertimeContext.Provider value={getInitialValue(rawData)}>
                {isLoading ? (
                    <SitesChartLoaderContainer>
                        <GraphLoader width={"100%"} />
                    </SitesChartLoaderContainer>
                ) : (
                    <div ref={chartRef}>
                        <ChartHeader chartRef={chartRef} />
                        <ChartDelimiter />
                        <ContentContainer>
                            <Chart
                                rawData={rawData}
                                chosenSitesLegends={chosenSitesLegends}
                            />
                            <Legends />
                        </ContentContainer>
                    </div>
                )}
            </OverlapOvertimeContext.Provider>
        </Container>
    );
};
